import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import APP from 'app';
import InputField from './InputField';
import Button from './button';
import Heading from './heading';
import ForgetPassword from './forget';
import { loginUser } from './../../../actions/userActions';
import ShowHidePassword from './hideShowPassword';
const { Utils } = APP, { translateText } = Utils;

class LoginComp extends Component {

    state = {
        loginData: {
            role: 'CUSTOMER'
        },
        showForget: false,
        error: false,
        showPassword: false
    }

    onChangeHandler = (value, context) => {
        this.setState({
            loginData: {
                ...this.state.loginData,
                [context]: value,
            },
            error: false
        })
    }

    showForgetHandler = () => {
        this.setState({
            showForget: !this.state.showForget
        })
    }

    onSubmitHandler = () => {
        const { loginData = {} } = this.state;
        const { username, password, role } = loginData;
        if (username && password) {
            const userInfo = { username, password, role };
            this.props.dispatch(loginUser(userInfo));
        } else {
            this.setState({ error: true });
        }
    }

    onKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.onSubmitHandler();
        }
    }

    onBlur = (event, field) => {
        if (this.state.errMsg) {
            this.validateByField(field);
        }
    }

    componentDidUpdate() {
        const error = this.state.error || null;
        if (error) {
            APP.Utils.errorToaster("Username or Email is invalid!");
        }
        if (this.props.loginSuccess) {
            this.props.onCloseModal();
        }
    }

    showHidePassword = () => {
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    render() {
        const { loginData = {}, showForget = false, showPassword = false, loading = false } = this.state;
        return (
            <Fragment>
                {!showForget ?
                    <Fragment>
                        <Heading
                            title={translateText('loginTitle', 'B2CLogin')}
                        />
                        <InputField
                            type='email'
                            placeholder={translateText('emailOrMobile', 'B2CLogin')}
                            context='username'
                            onChangeHandler={this.onChangeHandler}
                            name='emailorAddress'
                            value={loginData['username']}
                            handleKeyDown={this.onKeyDown}
                            onBlur={this.onBlur}
                        />
                        <div className="b2c__loginwrap--showhidepassword">
                            <InputField
                                type={showPassword ? 'text' : 'password'}
                                placeholder={translateText('password', 'B2CLogin')}
                                context='password'
                                onChangeHandler={this.onChangeHandler}
                                name='password'
                                value={loginData['password']}
                                handleKeyDown={this.onKeyDown}
                                onBlur={this.onBlur}
                            />
                            <ShowHidePassword
                                showPassword={showPassword}
                                showHidePassword={this.showHidePassword}
                            />
                        </div>
                        <p
                            className="b2c__loginwrap--forgotpass"
                            onClick={this.showForgetHandler}
                        >
                            {translateText('forgotPassword', 'B2CLogin')}
                        </p>
                        <Button
                            type='button'
                            onSubmitHandler={this.onSubmitHandler}
                            displayLabel={translateText('loginBtn', 'B2CLogin')}
                            disabled={loading}
                        />
                    </Fragment> :
                    <ForgetPassword
                        showForgetHandler={this.showForgetHandler}
                    />
                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    const { userinfos = {} } = state;
    const { userInfo = {}, success = false,
        registerSuccess, loading, } = userinfos;
    return {
        userInfo, loginSuccess: success,
        registerSuccess, loading
    }
};

const mapDispatchToProps = dispatch => {
    let actions = bindActionCreators({
        loginUser
    });
    return { actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginComp);
